import React, { useEffect, useState, useContext } from 'react'

import LoadingContext from '../../context/Loading/Loading'

import { getDefaultSeason } from '../../utilities/helpers'

import { getSeasons, getSeasonSummary } from '../../utilities/api'
import { useReportRefresh } from '../../hooks/useReportRefresh'

import Card from 'react-bootstrap/Card'

import { ReportActions } from '../ReportActions'
import { SeasonSelector } from '../SeasonSelector'
import SeasonReport from './SeasonReport'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { LoadingContainer } from '../LoadingContainer'
import { EmptyContainer } from '../EmptyContainer'

export default function SeasonSummaryWrapper({ organization }) {
  const { showLoading, hideLoading, isLoading } = useContext(LoadingContext)

  const [seasons, setSeasons] = useState()

  const [selectedSeason, setSelectedSeason] = useState()

  const [isLoadingData, setIsLoadingData] = useState(false)
  const { refreshToken, refresh, completeRefresh } =
    useReportRefresh(isLoadingData)

  const [data, setData] = useState([])

  const loadSeasons = () => {
    getSeasons(organization.uuid)
      .then((res) => {
        setSeasons(res.data)
        // select the current season - start and end time is in between current time
        const selected = getDefaultSeason(res.data)

        if (selected) setSelectedSeason(selected?.id)
        hideLoading()
      })
      .catch((err) => {
        console.error(err)
        hideLoading()
      })
  }

  const loadSeasonSummary = () => {
    setIsLoadingData(true)
    getSeasonSummary(organization.uuid, selectedSeason)
      .then((res) => {
        setData(res.data)
        setIsLoadingData(false)
        completeRefresh()
      })
      .catch((err) => {
        console.error(err)
        setIsLoadingData(false)
        completeRefresh()
      })
  }

  useEffect(() => {
    showLoading()
    loadSeasons()
  }, [])

  useEffect(() => {
    if (selectedSeason) loadSeasonSummary()
  }, [selectedSeason, refreshToken])

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer style="without-sidebar" />
      ) : (
        <section className="spacer-sm">
          <header className="section-header-sm">
            <div className="section-heading">
              <h1>Season summary</h1>
            </div>
            <p className="section-header-desc">
              This report summarizes event-by-event ticket sales across
              individual, group, and package ticket types for the selected
              season.
            </p>
          </header>
          {seasons?.length > 0 ? (
            <>
              <ReportActions
                isLoading={isLoadingData}
                onRefresh={refresh}
                isRefreshing={isLoadingData}
                selected={selectedSeason}
              >
                <SeasonSelector
                  seasons={seasons}
                  selected={selectedSeason}
                  setSelected={setSelectedSeason}
                  isLoading={isLoadingData}
                />
              </ReportActions>
              <Results
                selectedSeason={selectedSeason}
                isLoading={isLoadingData}
                data={data}
              />
            </>
          ) : (
            <Card body>
              <EmptyContainer style="center lg">
                <p>No seasons created</p>
                <p className="subtitle">
                  Create a season to start tracking its ticket sales.
                </p>
              </EmptyContainer>
            </Card>
          )}
        </section>
      )}
    </>
  )
}

function Results({ isLoading, selectedSeason, data }) {
  if (!selectedSeason) {
    return (
      <Card body>
        <EmptyContainer style="center lg">
          <p>Select a season to view its ticket sales</p>
        </EmptyContainer>
      </Card>
    )
  }
  if (isLoading) {
    return <LoadingContainer />
  }
  if (data?.length === 0) {
    return (
      <Card body>
        <EmptyContainer style="center lg">
          <p>No data</p>
          <p className="subtitle">
            There's currently no data for this season. Please choose another
            season.
          </p>
        </EmptyContainer>
      </Card>
    )
  }

  return <SeasonReport data={data} />
}
